export default function Footer() {
  return (
    <footer className="bg-gradient-to-br from-violet-600 to-purple-600 text-white py-16">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          {/* Brand */}
          <div className="md:col-span-1">
            <img
              src="https://static.readdy.ai/image/af84490e484a32258481d5416d7d609f/d78e5faf28d5fcd317efb0ee3ee0e6ef.png"
              alt="Cycle Clarity Logo"
              className="h-12 w-auto mb-4"
            />
            <p className="text-white/80 text-sm leading-relaxed">
              Empowering women to understand their bodies through simple, science-backed cycle tracking.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold mb-4">Quick Links</h3>
            <ul className="space-y-3">
              <li>
                <a href="/" className="text-white/80 hover:text-white transition-colors text-sm cursor-pointer">
                  Home
                </a>
              </li>
              <li>
                <a href="/about" className="text-white/80 hover:text-white transition-colors text-sm cursor-pointer">
                  About Us
                </a>
              </li>
              <li>
                <a href="#testimonials" className="text-white/80 hover:text-white transition-colors text-sm cursor-pointer">
                  Testimonials
                </a>
              </li>
              <li>
                <a href="/contact" className="text-white/80 hover:text-white transition-colors text-sm cursor-pointer">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-semibold text-lg mb-4">Get in Touch</h4>
            <ul className="space-y-3">
              <li className="flex items-center gap-2 text-violet-50 text-sm">
                <i className="ri-mail-line"></i>
                <a href="mailto:hachim47bl@gmail.com" className="hover:text-white transition-colors cursor-pointer">
                  hachim47bl@gmail.com
                </a>
              </li>
              <li className="flex items-center gap-2 text-violet-50 text-sm">
                <i className="ri-whatsapp-line"></i>
                <a href="https://wa.me/213662813514" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors cursor-pointer">
                  +213 662 813 514
                </a>
              </li>
              <li className="flex items-center gap-3 mt-4">
                <a href="https://www.facebook.com/abo.bouthina" target="_blank" rel="noopener noreferrer" className="w-8 h-8 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-full transition-colors cursor-pointer">
                  <i className="ri-facebook-fill"></i>
                </a>
                <a href="https://www.instagram.com/haithmi45/" target="_blank" rel="noopener noreferrer" className="w-8 h-8 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-full transition-colors cursor-pointer">
                  <i className="ri-instagram-line"></i>
                </a>
                <a href="https://x.com/hachoum47" target="_blank" rel="noopener noreferrer" className="w-8 h-8 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-full transition-colors cursor-pointer">
                  <i className="ri-twitter-x-line"></i>
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-violet-500 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-violet-50 text-sm">
            © 2026 Cycle Clarity. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-violet-50 hover:text-white text-sm transition-colors cursor-pointer">
              Privacy Policy
            </a>
            <a href="#" className="text-violet-50 hover:text-white text-sm transition-colors cursor-pointer">
              Terms of Service
            </a>
            <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-violet-50 hover:text-white text-sm transition-colors cursor-pointer">
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}